module.exports = __webpack_public_path__ + "fonts/sourcesansprobolditalic.32cc9abb.woff";